export const TITLE_DESKTOP = 'Нуждаетесь в помощи специалиста?';
export const TEXT_DESKTOP =
  'Мы поможем провести сделку быстро, безопасно и с максимальной выгодой с помощью подбора риелторов-партнёров Циан.';
export const TEXT_BUTTON_DESKTOP = 'Отправить заявку риелтору';

export const TITLE_MOBILE = 'Подберём специалиста';
export const TEXT_MOBILE =
  'Проведём сделку быстро, безопасно и с максимальной выгодой при помощи риелторов-партнёров Циан';
export const TEXT_BUTTON_MOBILE = 'Отправить заявку';
